import {
  DEFAULT_LISTS_IDS,
  TDetectionClassesItem,
  TDetectionVariantsItem,
} from "fieldpro-tools";

import { TABLE_COLUMN_TYPE } from "components/Table/model";

import { TTableConfig } from "./tableReducer";

export const DEFAULT_DETECTION_CLASSES_CONFIG: TTableConfig<
  keyof TDetectionClassesItem
> = {
  path: `/lists/${DEFAULT_LISTS_IDS.DETECTION_CLASSES}`,
  columnTypes: [
    {
      name: "_name",
      type: TABLE_COLUMN_TYPE.TEXT,
      label: "Name",
      hidden: false,
      unsortable: false,
    },
    {
      name: "_category",
      type: TABLE_COLUMN_TYPE.SINGLE_CHOICE,
      label: "Category",
      hidden: false,
      unsortable: false,
    },
    {
      name: "_status",
      type: TABLE_COLUMN_TYPE.SINGLE_CHOICE,
      label: "Status",
      hidden: false,
      unsortable: false,
    },
    {
      name: "_average_acc",
      type: TABLE_COLUMN_TYPE.NUMBER,
      label: "Average accuracy",
      hidden: false,
      unsortable: false,
    },
    {
      name: "_total_annotations",
      type: TABLE_COLUMN_TYPE.NUMBER,
      label: "total_annotations",
      hidden: false,
      unsortable: false,
    },
    {
      name: "_code",
      type: TABLE_COLUMN_TYPE.TEXT,
      label: "Code",
      hidden: false,
      unsortable: false,
    },
    {
      name: "_image_url",
      type: TABLE_COLUMN_TYPE.PICTURE,
      label: "Image URL",
      hidden: false,
      unsortable: true,
    },
    {
      name: "_displayed_name",
      type: TABLE_COLUMN_TYPE.TEXT,
      label: "Displayed Name",
      hidden: true,
      unsortable: false,
    },
    {
      name: "_total_variants_detected",
      type: TABLE_COLUMN_TYPE.NUMBER,
      label: "Variants",
      hidden: true,
      unsortable: false,
    },
    {
      name: "_class_item_1",
      type: TABLE_COLUMN_TYPE.SINGLE_CHOICE_ON_LIST,
      label: "Class Item",
      hidden: true,
      unsortable: true,
    },
  ],
};

export const DEFAULT_VARIANTS_CONFIG: TTableConfig<
  keyof TDetectionVariantsItem
> = {
  path: `/lists/${DEFAULT_LISTS_IDS.DETECTION_VARIANTS}`,
  columnTypes: [
    {
      name: "_name",
      type: TABLE_COLUMN_TYPE.TEXT,
      label: "Name",
      hidden: false,
      unsortable: false,
    },
    {
      name: "_variant_parent_class",
      type: TABLE_COLUMN_TYPE.TEXT,
      label: "Variant Parent Class",
      hidden: false,
      unsortable: false,
    },
    {
      name: "_status",
      type: TABLE_COLUMN_TYPE.SINGLE_CHOICE,
      label: "Status",
      hidden: false,
      unsortable: false,
    },
    {
      name: "_variant_source_list_item",
      type: TABLE_COLUMN_TYPE.TEXT,
      label: "Variant Source List Item",
      hidden: false,
      unsortable: false,
    },
    {
      name: "_accuracy",
      type: TABLE_COLUMN_TYPE.NUMBER,
      label: "Accuracy",
      hidden: false,
      unsortable: false,
    },
    {
      name: "_annotations",
      type: TABLE_COLUMN_TYPE.NUMBER,
      label: "Annotations",
      hidden: false,
      unsortable: false,
    },
    {
      name: "_image_url",
      type: TABLE_COLUMN_TYPE.PICTURE,
      label: "Image",
      hidden: false,
      unsortable: true,
    },
    {
      name: "_displayed_name",
      type: TABLE_COLUMN_TYPE.TEXT,
      label: "Item name",
      hidden: true,
      unsortable: false,
    },
  ],
};

export const initialState = {
  configs: [DEFAULT_DETECTION_CLASSES_CONFIG, DEFAULT_VARIANTS_CONFIG],
};

export default initialState;
